import {
  type App,
  EventEmitter,
  type Plugin,
  UniversalAppState,
  View,
} from "@pimo/pimo-app-builder";
import { DefaultLayout } from "@pimo/pimo-app-builder";

export class HomePlugin<AppState extends UniversalAppState>
  extends EventEmitter<"registered">
  implements Plugin<AppState, AppState>
{
  route?: Plugin<AppState, AppState>["route"];

  onRegister(app: App<AppState>): void {
    this.route = app.createRoute({
      path: "/",
      view: new View("home", new DefaultLayout()),
    });
  }
}
